export default __webpack_public_path__ + "static/media/zora-logo-color.edc12c79.svg";